import { Box, styled } from '@mui/material';

const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;

  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.action.focus};
  }

  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export default IconWrapper;
